import { useState } from "react";
import { Button } from "antd";
import { Play, CheckCircle } from "lucide-react";

export function DemoVideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);

  const features = [
    "Pick role",
    "Open slots",
    "Get paid (in future)",
    "Help students",
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
            See how OneGrad Community works
          </h2>

          {/* Video Player */}
          <div className="relative aspect-video bg-card rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="/onegrad-mentor-video-thumbnail-professional.png"
              alt="OneGrad Community Demo Video"
              className="w-full h-full object-cover"
            />

            {!isPlaying && (
              <div className="absolute inset-0 flex items-center justify-center bg-black/20">
                <Button
                  size="large"
                  onClick={() => setIsPlaying(true)}
                  className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full h-20 w-20 p-0"
                >
                  <Play className="h-8 w-8 ml-1" />
                </Button>
              </div>
            )}
          </div>

          {/* Feature Points */}
          <div className="flex flex-wrap justify-center gap-6 pt-8">
            {features.map((feature, index) => (
              <div key={feature} className="flex items-center space-x-2">
                <CheckCircle className="h-5 w-5 text-primary" />
                <span className="text-foreground font-medium text-lg">
                  {feature}
                </span>
                {index < features.length - 1 && (
                  <span className="text-muted-foreground ml-4">•</span>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
